
import { mapState } from 'vuex'
import { RoutesListFn } from '@/router'

export default {
  data() {
    return {
      active: this.$route.name,
      navTimer: null,
    }
  },
  computed: {
    ...mapState({
      site: (state) => state.site,
      isHdFtMobile: (state) => state.isHdFtMobile,
    }),
    lang() {
      return this.$route.params.lang
    },
    navList() {
      return this.getRouterList(this.site)
    },
  },
  watch: {
    $route: {
      handler() {
        this.active = this.$route.name
        this.initLineLocal()
      },
      immediate: true,
    },
    isHdFtMobile(nv) {
      if (!nv) {
        this.active = this.$route.name
        this.initLineLocal()
      }
    },
  },
  beforeDestroy() {
    // 👇 组件销毁前清除定时器，防止内存泄露
    if (this.navTimer) {
      clearTimeout(this.navTimer)
      this.navTimer = null
    }
  },
  methods: {
    initLineLocal() {
      this.$nextTick(() => {
        const content = this.$refs.content
        const line = this.$refs.line
        const active = content?.querySelector('.active')
        // 下划线固定 32px 宽（与样式 .line 一致），水平居中于选中项标题下方
        const lineWidth = 32
        const left =
          active?.offsetLeft + active?.offsetWidth / 2 - lineWidth / 2
        if (line) line.style = `transform: translateX(${left}px);left: 0;`
      })
    },
    change(nav) {
      if (this.active !== nav.name) {
        // 清除可能存在的旧定时器
        if (this.navTimer) {
          clearTimeout(this.navTimer)
        }
        this.navTimer = setTimeout(() => {
          this.active = nav.name
          this.$router.push({
            path: `/${this.site}/${this.lang}${nav.path}`,
          })
          this.navTimer = null // 执行后置空
        }, 0)
      }
    },
    getRouterList(site) {
      const router = RoutesListFn(site)
      const aboutChildren =
        router.find((it) => it.name === 'about')?.children || []
      const introRouter =
        aboutChildren.find((it) => it.name === 'intro')?.children || []
      return introRouter
    },
    getNavList() {
      const outList = [
        {
          id: 'about',
          iName: '关于顺丰',
          name: 'site-lang-about-intro-detail-about',
          title: this.$t('modules.intro.menu.about'),
        },
      ]
      const otherList = [
        {
          id: 'course',
          iName: '发展历程',
          name: 'site-lang-about-intro-detail-course',
          title: this.$t('modules.intro.menu.course'),
        },
        // {
        //   id: 'desire',
        //   iName: '公司愿景',
        //   name: 'site-lang-about-intro-detail-desire',
        //   title: this.$t('modules.intro.menu.desire'),
        // },
        {
          id: 'culture',
          iName: '公司文化',
          name: 'site-lang-about-intro-detail-culture',
          title: this.$t('modules.intro.menu.culture'),
        },
        {
          id: 'honor',
          iName: '公司荣誉',
          name: 'site-lang-about-intro-detail-honor',
          title: this.$t('modules.intro.menu.honor'),
        },
      ]
      return [...outList, ...otherList]
    },
  },
}
